import React from 'react'

const BackIcon = props => {
    const height = props.height || 20
    const width = props.width || 20
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30">
            <g stroke="#000" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13.125 6.25 3.75 15.625 13.125 25M3.75 15.625h22.5"/>
            </g>
        </svg>
    )
}

export default BackIcon
